module.exports = __webpack_public_path__ + "img/SplashInnovation1.d79bef20.jpg";